import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box } from "@mui/material";
import { GripVertical } from "lucide-react";

/**
 * Wraps a card component with dnd-kit sortable behavior for preview mode.
 * Shows a drag handle overlay in the top-left corner.
 */
const SortableCardWrapper = ({ id, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: "relative",
  };

  return (
    <Box ref={setNodeRef} style={style}>
      <Box
        {...attributes}
        {...listeners}
        sx={{
          position: "absolute",
          top: 8,
          left: 8,
          zIndex: 10,
          cursor: "grab",
          backgroundColor: "background.paper",
          borderRadius: 1,
          p: 0.5,
          display: "flex",
          alignItems: "center",
          boxShadow: 1,
          opacity: 0.7,
          "&:hover": { opacity: 1 },
          "&:active": { cursor: "grabbing" },
        }}
      >
        <GripVertical size={14} />
      </Box>
      {children}
    </Box>
  );
};

export default SortableCardWrapper;
